import { render } from "./Vanta.vue?vue&type=template&id=afb7fde0&ts=true"
import script from "./Vanta.vue?vue&type=script&lang=ts"
export * from "./Vanta.vue?vue&type=script&lang=ts"

import exportComponent from "/workspaces/hackerspace-lelab.github.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__